/**
 * Tour step definitions. Add or reorder steps here to change the tour flow.
 * stepId is used by layout components to know which target to highlight (e.g. 'sidebar').
 */
export type TourStepId = 'sidebar' | 'colourJourney' | 'colorAnalysisButton';

export interface TourStepConfig {
  id: TourStepId;
  title: string;
  /** Optional body text below the title */
  body?: string;
  /** Placement of tooltip relative to target: 'top' | 'bottom' | 'left' | 'right' */
  placement: 'top' | 'bottom' | 'left' | 'right';
}

export const TOUR_STEPS: TourStepConfig[] = [
  {
    id: 'sidebar',
    title: 'Your Color Toolkit where you can find anything',
    placement: 'right',
  },
  {
    id: 'colourJourney',
    title: 'Your Badges',
    body: 'Earn your badges every step of the way',
    placement: 'bottom',
  },
  {
    id: 'colorAnalysisButton',
    title: 'Let’s get your color analysis badge done!',
    placement: 'right',
  },
];
